module.exports = __webpack_public_path__ + "static/media/Uruguay.2cb2f82d.png";